import { makeStyles } from "@mui/styles";
import tinycolor from "tinycolor2";

export default makeStyles((theme) => ({
  head: {
    textAlign: "left",
    fontSize: "24px",
    fontWeight: 500
  },
  heading: {
    margin: 0,
    textAlign: "left",
    marginTop: "1.5rem"
  },
  subheading: {
    margin: 0,
    textAlign: "left",
    fontWeight: 400
  },
  rangediv: {
    display: "flex",
    alignItems: "Center",
    gap: "2rem",
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "1rem"
    }
  },
  range: {
    width: "70%",
    appearance: "none",
    height: "20px",
    background: `${theme.palette.primary.main} !important`,
    borderRadius: "40px",
    outline: "none",

    // Chrome/Safari/Edge
    "&::-webkit-slider-thumb": {
      appearance: "none",
      width: "30px",
      height: "30px",
      borderRadius: "50%",
      background: "#fff",
      border: `2px solid ${theme.palette.primary.main}`,
      cursor: "pointer"
    },
    [theme.breakpoints.down("650")]: {
      width: "100%"
    }
  },
  passdiv: {
    display: "flex",
    alignItems: "center",
    background: tinycolor(theme.palette.primary.main).lighten(70).toHexString(),
    padding: "0 0.5rem",
    width: "fit-content",
    justifyContent: "space-between",
    marginTop: "30px",
    fontSize: "2.5rem"
  },
  modalFooterBtn: {
    display: "flex",
    width: "100%",
    gap: "10px",
    alignItems: "center",
    justifyContent: "center",
    "@media (max-width: 500px)": {
      flexWrap: "wrap"
    }
  },
  generationTypeSection: {
    marginBottom: "20px",
    textAligh: "left",
    marginTop: "10px"
  },
  generationTypeLabel: {
    display: "block",
    fontWeight: "bold",
    color: "#555",
    marginBottom: "10px",
    fontSize: "16px",
    textAlign: "left"
  },
  generationTypeOptions: {
    display: "flex",
    gap: "20px",
    flexWrap: "wrap"
  },
  radioOption: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer",
    fontSize: "16px"
  },
  autoGenerateSection: {
    marginBottom: "20px"
  },
  autoGenerateHint: {
    color: "#666",
    fontSize: "14px",
    marginTop: "10px",
    fontStyle: "italic"
  },
  passwordInputWrapper: {
    marginBottom: "16px"
  },
  inputLabel: {
    display: "block",
    marginBottom: "8px",
    fontWeight: "bold",
    color: "#555",
    fontSize: "14px",
    textAlign: "left"
  },
  passwordInputContainer: {
    position: "relative",
    width: "100%"
  },
  passwordInput: {
    width: "100%",
    padding: "12px 45px 12px 12px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    marginBottom: "1px !important",
    background: "transparent",
    fontSize: "14px",
    "&:focus": {
      outline: "none",
      borderColor: "#007bff",
      boxShadow: "0 0 0 2px rgba(0, 123, 255, 0.25)"
    }
  },
  passwordToggle: {
    position: "absolute",
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: "16px",
    padding: "4px",
    borderRadius: "4px",
    "&:hover": {
      backgroundColor: "#f5f5f5"
    }
  },
  eyeIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "20px",
    height: "20px"
  }
}));
